<template>
  <div
    class="upload"
    :class="['upload-' + size]"
    :style="{
      marginTop: showBadge ? '15px' : '',
      width: showBadge ? '108px' : '192px'
    }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <template v-if="value">
      <img class="upload-img" :src="value" fit="cover" @load="handleImgLoad" />
      <span class="upload-img-actions" :style="{ opacity: opacity }">
        <span
          title="重新上传"
          class="upload-img-actions-item"
          @click="uploadImg"
        >
          <i class="el-icon-upload2"></i>
        </span>
        <span title="删除" class="upload-img-actions-item" @click="delImg">
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </template>
    <div
      v-show="!value"
      class="upload-action"
      ref="uploadPicker"
      :id="uploadId"
    >
      <img src="@/assets/images/add.png" class="add-icon" alt="" />
      <div class="des-word">{{ description }}</div>
    </div>
    <div v-if="showBadge" class="photo-index">
      {{ this.sort }}
    </div>
  </div>
</template>
<script>
import { initwebupload } from "@/utils/webuplaoderCon";
export default {
  name: "UploadPhoto",
  props: {
    value: String,
    size: {
      type: String,
      default: "normal"
    },
    idFlag: {
      type: String,
      default: "0"
    },
    description: {
      type: String,
      default: "上传封面"
    },
    sort: {
      type: Number
    },
    showBadge: {
      type: Boolean,
      default: false
    },
    sizeLimit: {
      type: Number,
      default: 200
    },
    imgType: {
      type: [String, Object],
      default: "images"
    }
  },
  data() {
    return {
      opacity: 0
    };
  },
  computed: {
    uploadId() {
      return `upload_image_${this._uid}`;
    }
  },
  mounted() {
    const that = this;
    this.$nextTick(function () {
      that.fileUploadFun();
    });
  },
  methods: {
    handleImgLoad() {
      this.$emit("img-loaded");
    },
    handleMouseEnter() {
      this.opacity = "1";
    },
    handleMouseLeave() {
      this.opacity = "0";
    },
    uploadImg() {
      this.$refs.uploadPicker.querySelector("input").click();
    },
    delImg() {
      this.$emit("input", "");
    },
    backFun(backValue) {
      this.$emit("input", backValue.fileUrl);
      this.$emit("change", backValue.fileUrl);
    },
    fileUploadFun() {
      initwebupload(
          "#" + this.uploadId,
          this.imgType,
          this.backFun,
          null,
          null,
          null,
          null,
          null,
          this.sizeLimit
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.upload {
  position: relative;
  font-size: 14px;
  &-img {
    width: 100%;
    height: 100%;
    &-actions {
      display: inline-block;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      left: 0;
      top: 0;
      cursor: default;
      color: #fff;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      &-item {
        cursor: pointer;
        + .upload-img-actions-item {
          margin-left: 30px;
        }
      }
    }
  }
  &-normal {
    width: 192px;
    height: 108px;
  }
  &-small {
    width: 72px;
    height: 72px;
  }
  &-action {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: content-box;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      border-color: #409eff;
    }
    /deep/.webuploader-pick-new {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    .add-icon {
      width: 24px;
      height: 24px;
    }
  }
  .photo-index {
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    color: #ffffff;
    text-align: center;
    line-height: 20px;
    background: #409eff;
    border-radius: 50%;
  }
  .des-word {
    padding: 0 10px;
  }
}
</style>
